import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { Cart } from "./Cart";
import { OnClick } from "../../dom-tools/EventListeners";
import { AssetsCart } from "../../../_rokojori.com/js/assets/AssetsCart";

export class CartItemAdder
{
  static readonly addToCart = new ElementAttribute( "add-to-cart" );
  static readonly addToWishlist = new ElementAttribute( "add-to-wishlist" );


  static applyOnDocument( cart:AssetsCart )
  {
    CartItemAdder.addToCart.forEachInDoc( e => this.applyOnElement( e, cart, false ) );
    CartItemAdder.addToWishlist.forEachInDoc( e => this.applyOnElement( e, cart, true ) );
  }

  static applyOnElement( element:Element, cart:AssetsCart, wishlist:boolean = true )
  {
    let attribute = wishlist ? CartItemAdder.addToWishlist : CartItemAdder.addToCart;

    OnClick.add( element as HTMLElement, 
      async ()=>
      {        
        let id = attribute.from( element );
        let result = await cart.add( id, wishlist );

        console.log( "result", result );
      } 
    )
  }
}